import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, Paper, Typography, Grid } from '@material-ui/core';
import { colorRotation } from 'utils/styles';
import { ReactComponent as AddAccountIcon } from 'assets/img-add-account.svg';
import TextHr from 'common/separator/TextHr.js';
import ToastMessage from 'common/alert/ToastMessage.js';
import AccountCard from './AccountCard.js';

const styles = (theme) => ({
  root: {
    textAlign: 'center',
    flex: 1,
    margin: `${theme.spacing(5)}px auto 0 auto`,
  },
  headings: {
    padding: `${theme.spacing(3)}px 0`,
  },
  content: {
    marginBottom: '10vh',
  },
  heading: {
    color: theme.palette.common.black,
  },
  subHeading: {
    color: theme.palette.common.darkerText,
    fontWeight: 'normal',
    marginTop: theme.spacing(1),
  },
  cards: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(5),
    textAlign: 'left',
  },
  addAccount: {
    width: 350,
    height: 190,
    padding: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    cursor: 'pointer',
    '&:hover': {
      border: `1px solid ${theme.palette.common.primary}`,
    },
    '& h5': {
      color: theme.palette.common.primary,
    },
  },
});

class AccountSelection extends React.Component {
  render() {
    const {
      classes,
      accounts,
      dateFormat,
      onAccountClick,
      onAddAccountClick,
      showAccountAdded,
    } = this.props;

    const activeAccounts =
      accounts && accounts.filter((a) => a.isActive || a.isSuspended);

    const unauthorisedAccounts =
      accounts && accounts.filter((a) => !a.isAuthorized);

    const inactiveAccounts =
      accounts &&
      accounts.filter((a) => a.isClosed && !a.isActive && a.isAuthorized);

    return (
      accounts && (
        <div className={classes.root}>
          {showAccountAdded && (
            <ToastMessage
              message="Your new account has been added succesfully"
              type="success"
            />
          )}
          <div className={classes.headings}>
            <Typography variant="h2" className={classes.heading}>
              {activeAccounts && activeAccounts.length > 0
                ? 'Choose an account'
                : 'You have no active accounts yet'}
            </Typography>
            <Typography variant="h4" className={classes.subHeading}>
              {activeAccounts && activeAccounts.length > 0
                ? 'Pick the account you will use to log into the account'
                : 'Have you joined other facilities such as gym, yoga, swimming class and so on or have family & other users? We provide all your billing transactions here if those facilities are our partners.'}
            </Typography>
          </div>
          {activeAccounts && (
            <div className={classes.cards}>
              <Grid
                container
                spacing={4}
                alignItems="flex-start"
                justify="center">
                {activeAccounts.map((account, index) => {
                  return (
                    <Grid
                      item
                      key={account.adfitNo}
                      data-testid={'account-selection-active'}>
                      <AccountCard
                        account={account}
                        onAccountClick={onAccountClick}
                        dateFormat={dateFormat}
                        status={account.isSuspended ? 'Suspended' : 'Active'}
                        color={colorRotation[index % colorRotation.length]}
                      />
                    </Grid>
                  );
                })}
                <Grid item>
                  <Paper
                    className={classes.addAccount}
                    onClick={onAddAccountClick}>
                    <div>
                      <AddAccountIcon />
                    </div>
                    <div>
                      <Typography variant="h5">Add new account</Typography>
                    </div>
                  </Paper>
                </Grid>
              </Grid>
            </div>
          )}

          {(inactiveAccounts || unauthorisedAccounts) && (
            <TextHr text="Inactive accounts below" hrWidth="100px" />
          )}

          {(inactiveAccounts || unauthorisedAccounts) && (
            <div className={classes.cards}>
              <Grid
                container
                spacing={4}
                alignItems="flex-start"
                justify="center"
                data-testid="account-selection-inactive">
                {inactiveAccounts &&
                  inactiveAccounts.map((account) => {
                    return (
                      <Grid item key={account.adfitNo}>
                        <AccountCard
                          account={account}
                          dateFormat={dateFormat}
                          status={'Cancelled'}
                          disabled={true}
                        />
                      </Grid>
                    );
                  })}
                {unauthorisedAccounts &&
                  unauthorisedAccounts.map((account) => {
                    return (
                      <Grid item key={account.adfitNo}>
                        <AccountCard
                          account={account}
                          dateFormat={dateFormat}
                          status={'Unauthorised'}
                          disabled={true}
                        />
                      </Grid>
                    );
                  })}
              </Grid>
            </div>
          )}
        </div>
      )
    );
  }
}

AccountSelection.propTypes = {
  classes: PropTypes.object.isRequired,
  accounts: PropTypes.array,
  onAccountClick: PropTypes.func,
};

export default withStyles(styles)(AccountSelection);
